import MonthlyReportBuilder from './MonthlyReportBuilder'

export default MonthlyReportBuilder
